import { useState, useEffect, useRef } from "react";
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import axios from "axios";
import { API_BASE_URL } from './config';
import "./style.css";

const MachineInfo = () => {
  const [isEdited, setIsEdited] = useState(false);
  const handleButtonEdit = () => {
    setIsEdited(!isEdited);
  };

  const handleUpload = (event, key) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setNewImage((prev) => ({
          ...prev,
          [key]: { image: reader.result },
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  const [machineData, setMachineData] = useState([]);
  const [machineDetails, setMachineDetails] = useState(null);

  const [editModel, setEditModel] = useState("");
  useEffect(() => {
    if (machineDetails) {
      setEditModel(machineDetails[0]?.機台型號 || "");
    }
  }, [machineDetails]);

  const [data, setData] = useState([]);
  const [NewImage, setNewImage] = useState({
    measurementPointFile: { image: "" },
    impactPositionFile: { image: "" },
    machineImageFile: { image: "" }
  });
  const measurementInputRef = useRef(null);
  const impactInputRef = useRef(null);
  const machineInputRef = useRef(null);

  const handleSave = async (id, updatedImages) => {
    console.log("Updating ID:", id);
    console.log("Updated Images:", updatedImages);

    if (!id) {
      console.error("Error: Missing ID");
      return;
    }

    if (!updatedImages) {
      console.error("Error: Missing updatedImages");
      return;
    }

    setIsEdited(false);

    // 檢查每個圖片欄位是否為空字串，如果是空字串就不更新
    const dataToSave = {};

    if (updatedImages.measurementPointFile?.image) {
      dataToSave.measurementPointFile = updatedImages.measurementPointFile;
    }

    if (updatedImages.impactPositionFile?.image) {
      dataToSave.impactPositionFile = updatedImages.impactPositionFile;
    }

    if (updatedImages.machineImageFile?.image) {
      dataToSave.machineImageFile = updatedImages.machineImageFile;
    }

    dataToSave.machineModel = editModel;

    if (Object.keys(dataToSave).length === 0) {
      console.error("Error: No valid images to update");
      return;
    }

    try {
      // 將有效(非空白圖片)的資料傳送給後端
      await axios.post(`${API_BASE_URL}/NewImageFormData`, {
        id,
        ...dataToSave
      });

      // 更新前端資料
      setData((prevData) =>
        prevData.map((machine) =>
          machine._id === id ? { ...machine, ...updatedImages } : machine
        )
      );

      // 更新前端顯示
      setMachineDetails(prev => {
        if (!prev) return prev;
        const updated = [{ ...prev[0], 機台型號: editModel }];
        return updated;
      });

      console.log(`${id} updated successfully`);
    } catch (error) {
      console.error(`Error updating ${id}:`, error);
    }
  };

  const location = useLocation();
  const tempdata = location.state?.tempdata || {};

  const { id: machineId } = useParams();

  const navigate = useNavigate();
  const onMachineManagement = (e) => {
    e.preventDefault();
    navigate('/machine-management');
  };

  useEffect(() => {
    const fetchMachineData = () => {
      const data = [
        {
          廠商: tempdata.company,
          客戶: tempdata.client,
          資料ID: tempdata.dataId,
          交機時間: tempdata.deliveryTime,
          客戶備註: tempdata.customerRemarks,
          機台型號: tempdata.machineModel,
          機台型式: tempdata.machineForm,
          測量時間: tempdata.measurementTime,
          測量地點: tempdata.measurementLocation,
          控制器類型: tempdata.controllerType,
          x軸行程: tempdata.travelX,
          y軸行程: tempdata.travelY,
          z軸行程: tempdata.travelZ,
          X軸馬達規格: tempdata.motorSpecX,
          Y軸馬達規格: tempdata.motorSpecY,
          Z軸馬達規格: tempdata.motorSpecZ
        }
      ];
      setMachineData(data);
      setMachineDetails(data);
    };

    if (machineId) {
      fetchMachineData();
    }
  }, [machineId]);

  if (!machineDetails) return <div>Loading...</div>;

  const { 廠商, 客戶, 資料ID, 交機時間, 客戶備註, 機台型號, 機台型式, 測量時間, 測量地點, 控制器類型, x軸行程, y軸行程, z軸行程, X軸馬達規格, Y軸馬達規格, Z軸馬達規格 } = machineDetails[0];

  return (
    <div className="d-flex flex-column flex-md-row" style={{ width: '81.7%', margin: '0 auto' }}>
      <div className="container-fluid">
        <div style={{ height: '35px', width: '100%' }}></div>

        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#" onClick={onMachineManagement} style={{ color: '#B0B7C3', fontWeight: 'bold', fontSize: '15px' }}>機台資料庫</a>
            </li>
            <li className="breadcrumb-item" aria-current="page" style={{ color: '#5B82B1', fontWeight: 'bold', fontSize: '15px' }}>
              資料檢視 {機台型號}
            </li>
          </ol>
        </nav>

        <div style={{ height: '10px', width: '100%' }}></div>

        <form>
          <div className="d-flex flex-column">

            <div className="flex-row">
              <span className="sub-title">基本資料</span>
              <button
                type="button"
                className="edit-bnt bi bi-pencil"
                onClick={handleButtonEdit}
                style={{ color: isEdited ? '#E3E3E3' : '#757575' }}
              >
              </button>
            </div>

            <div style={{ height: '30px', width: '100%' }}></div>

            <div className="d-flex flex-column flex-md-row">
              <div className="p-1 flex-fill">
                <div className="row mb-3">
                  <label htmlFor="inputNo1" className="col-sm-2 col-form-label text-sm-start text-start" style={{ minWidth: "120px" }}>廠商</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control" id="inputNo1" defaultValue={廠商} readOnly />
                  </div>
                </div>

                <div className="row mb-3">
                  <label htmlFor="inputNo2" className="col-sm-2 col-form-label text-sm-start text-start" style={{ minWidth: "120px" }}>客戶</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control" id="inputNo2" defaultValue={客戶} readOnly />
                  </div>
                </div>

                <div className="row mb-3">
                  <label htmlFor="inputNo3" className="col-sm-2 col-form-label text-sm-start text-start" style={{ minWidth: "120px" }}>資料ID</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control" id="inputNo3" defaultValue={資料ID} readOnly />
                  </div>
                </div>

                <div className="row mb-3">
                  <label htmlFor="inputNo4" className="col-sm-2 col-form-label text-sm-start text-start" style={{ minWidth: "120px" }}>交機時間</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control" id="inputNo4" defaultValue={交機時間} readOnly />
                  </div>
                </div>

                <div className="row mb-3">
                  <label htmlFor="inputNo5" className="col-sm-2 col-form-label text-sm-start text-start" style={{ minWidth: "120px" }}>客戶備註</label>
                  <div className="col-sm-9">
                    <textarea className="form-control" id="inputNo5" rows="1" defaultValue={客戶備註} style={{ resize: "none", overflow: "hidden" }} onInput={(e) => e.target.style.height = `${e.target.scrollHeight}px`} readOnly />
                  </div>
                </div>
              </div>

              <div className="p-1 flex-fill">
                <div className="row mb-3">
                  <label htmlFor="inputNo6" className="col-sm-2 col-form-label text-sm-start text-start" style={{ minWidth: "120px" }}>機台型號</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      id="inputNo6"
                      value={isEdited ? editModel : 機台型號}
                      readOnly={!isEdited}
                      onChange={e => isEdited && setEditModel(e.target.value)}
                    />
                  </div>
                </div>

                <div className="row mb-3">
                  <label htmlFor="inputNo7" className="col-sm-2 col-form-label text-sm-start text-start" style={{ minWidth: "120px" }}>機台型式</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control" id="inputNo7" defaultValue={機台型式} readOnly />
                  </div>
                </div>

                <div className="row mb-3">
                  <label htmlFor="inputNo8" className="col-sm-2 col-form-label text-sm-start text-start" style={{ minWidth: "120px" }}>測量時間</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control" id="inputNo8" defaultValue={測量時間} readOnly />
                  </div>
                </div>

                <div className="row mb-3">
                  <label htmlFor="inputNo9" className="col-sm-2 col-form-label text-sm-start text-start" style={{ minWidth: "120px" }}>測量地點</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control" id="inputNo9" defaultValue={測量地點} readOnly />
                  </div>
                </div>

                <div className="row mb-3">
                  <label htmlFor="inputNo10" className="col-sm-2 col-form-label text-sm-start text-start" style={{ minWidth: "120px" }}>控制器類型</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control" id="inputNo10" defaultValue={控制器類型} readOnly />
                  </div>
                </div>
              </div>

            </div>

            <div style={{ height: '35px', width: '100%' }}></div>

            <span className="sub-title">機台資料</span>
            <div style={{ height: '35px', width: '100%' }}></div>

            <div className="d-flex flex-column flex-md-row">
              <div className="p-1 flex-fill">
                <div className="row mb-3">
                  <label htmlFor="inputNo14" className="col-sm-2 col-form-label text-sm-start text-start" style={{ minWidth: "120px" }}>X軸行程</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control" id="inputNo14" defaultValue={x軸行程} readOnly />
                  </div>
                </div>

                <div className="row mb-3">
                  <label htmlFor="inputNo15" className="col-sm-2 col-form-label text-sm-start text-start" style={{ minWidth: "120px" }}>Y軸行程</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control" id="inputNo15" defaultValue={y軸行程} readOnly />
                  </div>
                </div>

                <div className="row mb-3">
                  <label htmlFor="inputNo16" className="col-sm-2 col-form-label text-sm-start text-start" style={{ minWidth: "120px" }}>Z軸行程</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control" id="inputNo16" defaultValue={z軸行程} readOnly />
                  </div>
                </div>
              </div>

              <div className="p-1 flex-fill">
                <div className="row mb-3">
                  <label htmlFor="inputNo11" className="col-sm-2 col-form-label text-sm-start text-start" style={{ minWidth: "120px" }}>X軸馬達規格</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control" id="inputNo11" defaultValue={X軸馬達規格} readOnly />
                  </div>
                </div>

                <div className="row mb-3">
                  <label htmlFor="inputNo12" className="col-sm-2 col-form-label text-sm-start text-start" style={{ minWidth: "120px" }}>Y軸馬達規格</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control" id="inputNo12" defaultValue={Y軸馬達規格} readOnly />
                  </div>
                </div>

                <div className="row mb-3">
                  <label htmlFor="inputNo13" className="col-sm-2 col-form-label text-sm-start text-start" style={{ minWidth: "120px" }}>Z軸馬達規格</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control" id="inputNo13" defaultValue={Z軸馬達規格} readOnly />
                  </div>
                </div>
              </div>

            </div>

            <div style={{ height: '35px', width: '100%' }}></div>

            <span className="sub-title">測量記錄</span>

            <div style={{ height: '35px', width: '100%' }}></div>

            <div className="d-flex flex-column flex-md-row">

              <div className="flex-fill text-center" style={{ margin: "10px", width: "100%" }}>
                <div
                  className="card d-flex justify-content-center align-items-center flex-fill"
                  style={{
                    marginBottom: "20px",
                    padding: isEdited ? "10px" : "0px",
                    border: isEdited ? "2px dashed #B7CCDF" : "none",
                    borderRadius: "5px",
                    height: "230px",
                    width: "100%",
                    position: "relative",
                    cursor: isEdited ? "pointer" : "default"
                  }}
                  onClick={() => isEdited && measurementInputRef.current.click()}
                >
                  {isEdited && !NewImage.measurementPointFile.image ? (
                    <span style={{ color: "#999", fontSize: "14px" }}>選擇檔案</span>
                  ) : (
                    <img
                      src={NewImage.measurementPointFile.image || tempdata.measurementPointFile?.image || ""}
                      className="card-img img-fluid"
                      alt=""
                      style={{
                        height: "100%",
                        width: "100%",
                        objectFit: "cover",
                        backgroundColor: isEdited && !NewImage.measurementPointFile.image ? "#f0f0f0" : "transparent"
                      }}
                    />
                  )}
                </div>
                <label htmlFor="measurementPointUploadInput" style={{ fontSize: "15px", marginBottom: "5px" }}>
                  量測點位
                </label>
                {isEdited && <input type="file" ref={measurementInputRef} style={{ display: "none" }} onChange={(e) => handleUpload(e, "measurementPointFile")} />}
              </div>

              <div className="flex-fill text-center" style={{ margin: "10px", width: "100%" }}>
                <div
                  className="card d-flex justify-content-center align-items-center flex-fill"
                  style={{
                    marginBottom: "20px",
                    padding: isEdited ? "10px" : "0px",
                    border: isEdited ? "2px dashed #B7CCDF" : "none",
                    borderRadius: "5px",
                    height: "230px",
                    width: "100%",
                    position: "relative",
                    cursor: isEdited ? "pointer" : "default"
                  }}
                  onClick={() => isEdited && impactInputRef.current.click()}
                >
                  {isEdited && !NewImage.impactPositionFile.image ? (
                    <span style={{ color: "#999", fontSize: "14px" }}>選擇檔案</span>
                  ) : (
                    <img
                      src={NewImage.impactPositionFile.image || tempdata.impactPositionFile?.image || ""}
                      className="card-img img-fluid"
                      alt=""
                      style={{
                        height: "100%",
                        width: "100%",
                        objectFit: "cover",
                        backgroundColor: isEdited && !NewImage.impactPositionFile.image ? "#f0f0f0" : "transparent"
                      }}
                    />
                  )}
                </div>
                <label htmlFor="impactPointUploadInput" style={{ fontSize: "15px", marginBottom: "5px" }}>
                  敲擊位置
                </label>
                {isEdited && <input type="file" ref={impactInputRef} style={{ display: "none" }} onChange={(e) => handleUpload(e, "impactPositionFile")} />}
              </div>

              <div className="flex-fill text-center" style={{ margin: "10px", width: "100%" }}>
                <div
                  className="card d-flex justify-content-center align-items-center"
                  style={{
                    marginBottom: "20px",
                    padding: isEdited ? "10px" : "0px",
                    border: isEdited ? "2px dashed #B7CCDF" : "none",
                    borderRadius: "5px",
                    height: "230px",
                    width: "100%",
                    position: "relative",
                    cursor: isEdited ? "pointer" : "default"
                  }}
                  onClick={() => isEdited && machineInputRef.current.click()}
                >
                  {isEdited && !NewImage.machineImageFile.image ? (
                    <span style={{ color: "#999", fontSize: "14px" }}>選擇檔案</span>
                  ) : (
                    <img
                      src={NewImage.machineImageFile.image || tempdata.machineImageFile?.image || ""}
                      className="card-img img-fluid"
                      alt=""
                      style={{
                        height: "100%",
                        width: "100%",
                        objectFit: "cover",
                        backgroundColor: isEdited && !NewImage.machineImageFile.image ? "#f0f0f0" : "transparent"
                      }}
                    />
                  )}
                </div>
                <label htmlFor="machineImageUploadInput" style={{ fontSize: "15px", marginBottom: "5px" }}>
                  機台型式
                </label>
                {isEdited && <input type="file" ref={machineInputRef} style={{ display: "none" }} onChange={(e) => handleUpload(e, "machineImageFile")} />}
              </div>
            </div>

            {isEdited && tempdata._id && (
              <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "10px" }}>
                <button
                  className="btn-save"
                  onClick={() => handleSave(tempdata._id, NewImage)}
                >
                  儲存
                </button>
              </div>
            )}

            <div style={{ height: '45px', width: '100%' }}></div>

          </div>
        </form>
      </div >
    </div >
  );
};

export default MachineInfo;